var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAxa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 33,
    viewBox: "0 0 36 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.504211 0.822754V32.8106H35.4538V0.822754H0.504211ZM25.985 30.7003C25.8737 29.9601 25.7733 29.6126 25.6296 29.1881L24.5277 25.7514H19.6318L18.7525 26.8829L19.5422 29.2108C19.6983 29.7002 19.8652 30.0809 20.1542 30.7003H17.3724L16.9165 29.2108L15.8038 30.7003H13.5676L13.0885 29.2213L11.9094 30.7003H9.81688H9.67161C9.72725 30.6565 9.77207 30.6126 9.81688 30.5703C10.3841 30.0809 10.741 29.6353 11.0517 29.2319L12.4765 27.404L11.9202 25.7514H7.03514L3.21796 30.7003H0.847294C1.74827 29.9389 1.98163 29.7002 2.31544 29.2652L9.54798 19.9218C9.64843 19.7919 9.73652 19.6605 9.81534 19.52C9.94824 19.3025 10.0719 19.0517 10.1383 18.7481H12.4858C12.4858 19.2587 12.5631 19.5427 12.6744 19.9339L14.3218 24.981L15.1671 23.8933L13.8211 19.8795C13.7206 19.5865 13.5985 19.2058 13.3543 18.7481H16.2025C16.2798 19.1937 16.3586 19.5532 16.4807 19.9445L17.0031 21.5216L18.227 19.9339C18.5052 19.5638 18.8838 19.1514 19.0507 18.7481H21.5435C21.0536 19.1287 20.743 19.5306 20.4416 19.9112L17.6815 23.49L18.1606 24.9689L22.1107 19.9218C22.2111 19.7692 22.3224 19.6393 22.4336 19.4973C22.5789 19.2798 22.701 19.0517 22.7783 18.7465H25.1041C25.1381 19.1484 25.1938 19.4973 25.305 19.8674L28.2985 29.2002C28.4438 29.7002 28.5427 30.0054 28.9213 30.7018H25.985V30.7003Z",
    fill: "#8F8F8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.14948 24.2725H11.4876L10.4738 21.2588L8.14948 24.2725Z",
    fill: "#8F8F8F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.936 26.818L15.4691 28.4706L16.3269 27.3724L15.7365 25.7515L14.936 26.818Z",
    fill: "#8F8F8F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8212 24.2725H24.0481L23.0358 21.2588L20.8212 24.2725Z",
    fill: "#8F8F8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAxa);
export default __webpack_public_path__ + "static/media/AXA.ee21c1485bdfe585d38e8d2e3b8410c2.svg";
export { ForwardRef as ReactComponent };